import { useCallback, useMemo } from 'react';
import { BeraResultCycleSummary } from '@/types/Bera';

type HighlightParams = {
	type: 'step' | 'task-total';
	taskIndex: number;
	scoreIndex: number;
	value: number;
};

export function useENS(cycleSummary: BeraResultCycleSummary) {
	const tasksWithHighScores = useMemo(
		() =>
			new Set(
				cycleSummary.task_rpn_scores
					.map((task, index) => ({
						index,
						hasHighScore: task.rpn_scores.some((score) => score.task_rpn > 15) || task.rpn > 15
					}))
					.filter((item) => item.hasHighScore)
					.map((item) => item.index)
			),
		[cycleSummary]
	);

	return useCallback(
		(params: HighlightParams): string => {
			if (params.type === 'step') {
				return params.value > 15 ? 'red' : 'black';
			}

			if (params.type === 'task-total') {
				return tasksWithHighScores.has(params.taskIndex) ? 'red' : 'green';
			}

			return 'black';
		},
		[tasksWithHighScores]
	);
}
